import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {Button, Col, Empty, Form, Input, Row} from 'antd'
import RolesParserService from "../../services/parsers/roles.parser.service";
import PermissionSelector from "../../components/shared/permission-selector/PermissionSelector";
import {useHistory} from "react-router-dom";

const PermissionRoleDetails = ({permission, searchedPermissions}) => {
    const [parsedRolesPermissions, setParsedRolesPermissions] = useState({})
    const navigate = useHistory();
    useEffect(() => {
        if (permission.RolesPermissions) {
            const parsedData = RolesParserService.parseRolesPermissionList(permission.RolesPermissions);
            console.log({parsedData})
            setParsedRolesPermissions(parsedData.parsedRolesPermissionMap);
        }
    }, [permission])

    return (
        <div className="inner-section">
            <div className="header-container">
                <div className="role-permission-header">
                    Roles with this permission attached
                </div>
            </div>
            <div className="main-section">
                {
                    Object.keys(parsedRolesPermissions).map((permRow) => (
                        <Row gutter={[12, 0]}>
                            <Col span={8}>
                                <Form.Item label="Name" labelCol={{ span: 24 }}>
                                    <Input name="name" type="text" placeholder="Name" size="large" value={parsedRolesPermissions[permRow].Role.name} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Description" labelCol={{ span: 24 }}>
                                    <Input name="description" type="text" placeholder="Description" size="large" value={parsedRolesPermissions[permRow].Role.description} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item label="Details" labelCol={{ span: 24 }}>
                                    <Button type="primary" className="detail-btn" onClick={() => {  navigate.push(`/groups/${parsedRolesPermissions[permRow].Role.id}`) }}>Details</Button>
                                </Form.Item>
                            </Col>
                            <Col span={20}>
                                <PermissionSelector
                                    viewMode={true}
                                    onChange={() => {}}
                                    searchedPermissions={searchedPermissions}
                                    selectedPermissions={parsedRolesPermissions[permRow].selectedPermissions}
                                />
                            </Col>
                        </Row>
                    ))
                }
                {
                    Object.keys(parsedRolesPermissions).length === 0 && (
                        <Empty style={{margin: 0}} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                }
            </div>
        </div>
    )
}
const mapStateToProps = ({ permissionsState }) => {
    return {
        permission: permissionsState.selectedPermissionInputs,
        searchedPermissions: permissionsState.permissions,
    }
}

export default connect(mapStateToProps)(PermissionRoleDetails)
